import React from 'react';
import { cx, css } from 'emotion';
import { Link } from 'react-router-dom';
import ProductLink from '@jetshop/ui/ProductLink';
import CategoryLink from '@jetshop/ui/CategoryLink';

const block = css`
  display: block;
  text-decoration: none;
  color: inherit;
`;

const inline = css`
  display: inline;
`;

export function isRelativeUrl(url) {
  return url && !url.startsWith('http://') && !url.startsWith('https://');
}

export const Linker = ({
  to,
  category,
  product,
  type = 'block',
  style = {},
  children,
  className,
  ...rest
}) => {
  // type can be 'block', 'inline', 'button-neutral', 'button-cta'
  const typeClasses = {
    block: block,
    inline: inline
  };

  const typeClass = typeClasses[type];

  if (product) {
    return (
      <ProductLink
        product={product}
        className={cx(className, typeClass)}
        style={style}
        {...rest}
      >
        {children}
      </ProductLink>
    );
  } else if (category) {
    return (
      <CategoryLink
        category={category}
        className={cx(className, typeClass)}
        style={style}
        {...rest}
      >
        {children}
      </CategoryLink>
    );
  } else if (to) {
    if (typeof to === 'string' && !isRelativeUrl(to)) {
      return (
        <a href={to}
           className={cx(className, typeClass)}
           style={style}
           target={to.match(/checkout/i) ? '_self' : '_blank'}
        >
          {children}
        </a>
      );
    } else {
      return (
        <Link
          to={to}
          className={cx(className, typeClass)}
          style={style}
          {...rest}
        >
          {children}
        </Link>
      );
    }
  } else {
    return <div className="no-href">{children}</div>;
  }
};
